export default function Blank() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 35 35">
      <circle id="Ellipse_1" data-name="Ellipse 1" cx="20" cy="20" fill="#fff" />
    </svg>
  );
}
